
// ─── Page ───
export const createRuleContainerSx = { p: 3 };

export const createRuleTitleSx = {
  fontFamily: 'Nunito',
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#232323',
  mb: 3,
};

// ─── Section ───
export const sectionTitleSx = {
  fontFamily: 'Nunito',
  fontWeight: 700,
  fontSize: '0.9375rem',
  color: '#232323',
  mb: 2,
};

export const sectionBoxSx = { mb: 2, pb:2 , borderBottom: '1px solid #E2E3E5' };

// ─── Inputs ───
export const formFieldSx = {
  '& .MuiInputLabel-root': { px: 1, borderRadius: 2 , backgroundColor: '#fff'},
  '& .MuiInputBase-root': { backgroundColor: '#fff' },
  '& .MuiInputBase-root.Mui-disabled': { backgroundColor: '#f5f5f5' },
};


// ─── Workflow Builder ───
export const workflowCardSx = {
  background:'#F8F8F9',
  borderRadius: '0.75rem',
  p: 2.5,
  mb: 2,
};

export const removeWorkflowBtnSx = {
  color: '#EF4444',
  '&:hover': { backgroundColor: 'rgba(239,68,68,0.08)' },
};

export const addLevelBtnSx = {
  textTransform: 'none' as const,
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.875rem',
  color: '#5A8AEA',
  '&:hover': { backgroundColor: 'rgba(90,138,234,0.08)' },
};

export const mandatoryToggleSx = {
  width: '2.625rem',
  height: '1.5rem',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '0.1875rem',
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(1.125rem)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#22C55E',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '1.125rem',
    height: '1.125rem',
  },
  '& .MuiSwitch-track': {
    borderRadius: '0.75rem',
    backgroundColor: '#C4C4C4',
    opacity: 1,
  },
};

export const toggleLabelSx = {
  fontFamily: 'Nunito',
  fontSize: '0.8125rem',
  color: '#232323',
  fontWeight: 600,
  ml: 1,
};


export const toggleActiveLabelSx = {
  fontFamily: 'Nunito',
  fontSize: '0.8125rem',
  color: '#9E9E9E',
  fontWeight: 400,
  ml: 1,
};

// ─── Footer ───
export const footerContainerSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 2,
  pt: 3,
};

export const cancelBtnSx = {
  borderRadius: '0.5rem',
  textTransform: 'none' as const,
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.875rem',
  color: '#505050',
  borderColor: '#E0E0E0',
  '&:hover': { borderColor: '#CCCCCC', backgroundColor: '#F5F5F5' },
  px: 3,
  py: 1,
};

export const previewBtnSx = {
  borderRadius: '0.5rem',
  textTransform: 'none' as const,
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.875rem',
  color: '#505050',
  borderColor: '#E0E0E0',
  '&:hover': { borderColor: '#CCCCCC', backgroundColor: '#F5F5F5' },
  px: 3,
  py: 1,
};

export const saveRuleBtnSx = {
  borderRadius: '0.5rem',
  textTransform: 'none' as const,
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '0.875rem',
  backgroundColor: '#1F2937',
  '&:hover': { backgroundColor: '#111827' },
  px: 3,
  py: 1,
};


export const checkBoxSx = {
  '&.Mui-checked': { color: '#4CAF50', bgcolor: '#EAF7EA', borderRadius: 2 },
  '&.Mui-disabled': { color: '#ccc', opacity: 0.5 }
};

export const notifyLabelCheckedSx = {
  '& .MuiFormControlLabel-label': { color: '#232323' , fontWeight: 600, fontSize: '0.875rem', fontFamily: 'Nunito' },
};

export const notifyLabelUncheckedSx = {
  '& .MuiFormControlLabel-label': { color: '#9E9E9E' , fontWeight: 400, fontSize: '0.875rem', fontFamily: 'Nunito' },
};

export const addLevelInfoBoxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  color: '#B45309',
  bgcolor: '#FFFBEB',
  border: '1px solid #FDE68A',
  borderRadius: 1,
  px: 1,
  py: 0.4,
};

// ─── Preview Workflow Modal ───
export const previewModalContainerSx = {
  width: 'max-content',
  maxWidth: '95vw',
  bgcolor: 'background.paper',
  borderRadius: 4,
  mx: 'auto',
  mt: '5%',
  boxShadow: 24,
  outline: 'none',
  overflow: 'hidden',
};

export const previewHeaderRowSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 3,
  px: 3,
  py: 1,
};

export const previewHeaderItemSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: 0.5,
  minWidth: '10rem',
};

export const previewHeaderLabelSx = {
  fontFamily: 'Nunito',
  fontWeight: 400,
  fontSize: '1rem',
  color: '#BBBBBB',
};

export const previewHeaderValueSx = {
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '1rem',
  color: '#232323',
};

export const previewHeaderDividerSx = {
  width: '1px',
  alignSelf: 'stretch',
  backgroundColor: '#E2E3E5',
};

export const previewFlowContainerSx = {
  display: 'flex',
  alignItems: 'stretch',
  gap: 1.5,
  px: 3,
  py: 3,
  overflowX: 'auto' as const,
};

export const previewFlowCardSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  justifyContent: 'center',
  width: '11rem',
  flexShrink: 0,
  flexGrow: 0,
  border: '1px solid #E2E3E5',
  borderRadius: '0.75rem',
  p: 2,
  textAlign: 'center' as const,
};

export const previewFlowIconWrapperSx = {
  width: '3rem',
  height: '3rem',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 1,
};

export const previewRequestIconSx = {
  backgroundColor: '#EBF1FC',
};

export const previewRoleIconSx = {
  backgroundColor: '#FFF0E5',
};

export const previewApprovedIconSx = {
  backgroundColor: '#ECFDF5',
};

export const previewFlowCardTitleSx = {
  fontFamily: 'Nunito',
  fontWeight: 600,
  fontSize: '1rem',
  color: '#232323',
};

export const previewFlowCardSubTextSx = {
  fontFamily: 'Nunito',
  fontWeight: 400,
  fontSize: '0.8125rem',
  color: '#9E9E9E',
  mt: 0.5,
};

export const previewArrowSx = {
  color: '#232323',
  fontSize: '1.5rem',
  mx: 1,
  flexShrink: 0,
  alignSelf: 'center',
};

export const previewFooterSx = {
  display: 'flex',
  gap: 2,
  p: 3,
  pt: 0,
  justifyContent: 'flex-end',
};

export const previewFooterButtonsSx = {
  display: 'flex',
  gap: 2,
  width: '17rem',
};
